// ReportDepartmentFilter — фильтр департамента для отчётов (V14 W9, ТЗ §3.6).
// Рендерится ТОЛЬКО для admin (ReportsPage проверяет роль): передать departmentId
// для head/user → 403 на BЭ (§3.5). Список — useDepartments (U-14, api/departments.ts).
// Для lead-conversion фильтр не рендерится (useDepartment=false в каталоге: 400 на BЭ).

import { FormControl, InputLabel, MenuItem, Select } from '@mui/material';
import { useDepartments } from '@/api/departments';
import { t } from '@/i18n';

interface ReportDepartmentFilterProps {
  /** Выбранный департамент (null = все). */
  value: string | null;
  onChange: (value: string | null) => void;
}

/** Select департамента для отчётов (admin-only; «Все департаменты» = без фильтра). */
export function ReportDepartmentFilter({ value, onChange }: ReportDepartmentFilterProps): JSX.Element {
  const departments = useDepartments();

  return (
    <FormControl size="small" sx={{ minWidth: 220 }} data-testid="report-department-filter">
      <InputLabel>{t('reports.department')}</InputLabel>
      <Select
        label={t('reports.department')}
        value={value ?? ''}
        onChange={(event) => onChange(event.target.value === '' ? null : String(event.target.value))}
        inputProps={{ 'aria-label': t('reports.department') }}
      >
        <MenuItem value="">{t('reports.department.all')}</MenuItem>
        {(departments ?? []).map((department) => (
          <MenuItem key={department.id} value={department.id}>
            {department.name}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
}
